import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyTopBar() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-dark text-white py-2 px-4 shadow-md" data-id="element-288">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4 text-sm md:text-base" data-id="element-289">
        <div className="flex items-center gap-2 font-bold text-center" data-id="element-290">
          <span className="animate-pulse" data-id="element-291">⏰</span>
          <span data-id="element-292">PRECIO DE RELANZAMIENTO — Cierra en:</span>
          <span className={`text-brand-orange font-black text-lg tracking-wider ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-293">
            {formatTime(minutes)}:{formatTime(seconds)}
          </span>
        </div>
        <a href="https://checkout.guiadigital360.online/cart/44005388255301:1" className="bg-brand-green hover:bg-[#009a6a] text-white font-bold py-1 px-4 rounded-full text-sm transition-colors whitespace-nowrap" data-id="element-294">
          ASEGURAR PRECIO
        </a>
      </div>
    </div>;
}